import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { MainLoader } from "CommonComponent";
import { SETUP_TABS } from "./constants/jobEmailConfig";
import { JobEmailConfigurationTab } from "./component";
import "./SetupConfiguration.css";

const TAB_COMPONENTS = {
  job_email: <JobEmailConfigurationTab />,
};

const SetupConfiguration = () => {
  const [activeTab, setActiveTab] = useState(SETUP_TABS[0]?.id || "job_email");
  const setupConfigState = useSelector((state) => state.setupConfigState);

  return (
    <div className="wrapper-div">
      {setupConfigState?.loading ? <MainLoader /> : null}

      <div className="px-3 pt-3">
        <p className="setup-breadcrumb mb-1">SETUP</p>
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="font-24 font-weight-bold heading-color m-0">
            Configuration
          </h3>
        </div>
      </div>

      <div className="p-3">
        <div className="setup-category">
          <Tab.Container
            activeKey={activeTab}
            onSelect={(tabKey) => tabKey && setActiveTab(tabKey)}
          >
            <Nav variant="tabs" className="form-tabs">
              {SETUP_TABS.map((tab) => (
                <Nav.Item key={tab.id}>
                  <Nav.Link eventKey={tab.id}>{tab.label.toUpperCase()}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>

            <Tab.Content className="setup-tab-content">
              {SETUP_TABS.map((tab) => (
                <Tab.Pane key={tab.id} eventKey={tab.id}>
                  {TAB_COMPONENTS[tab.id]}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

export default SetupConfiguration;
